module.exports = __webpack_public_path__ + "img/528bee7.png";